type ProductKey =
    | 'privateContent'
    | 'youthContent'
    | 'travel'
    | 'car'
    | 'accident'
    | 'youngAccident'
    | 'childAccident'
    | 'dog'
    | 'cat'
    | 'house'
    | 'holidayHome'
    | 'salaryProtection'
    | 'horse'
    | 'singleTripTravel'
    | 'singleTripTravelCancellation'
    | 'motorcycle'
    | 'boat'
    | 'moped'
    | 'caravan'
    | 'changeOfOwnership';

interface Category {
    label: string;
    iconShape: string;
    products: ProductKey[];
}

interface Product {
    title: string;
    iconShape: string;
    supported: boolean;
    quantitySelector?: boolean;
}

type ProductCollection = Record<ProductKey, Product>;

const categories: Category[] = [
    {
        label: 'Mest Populære',
        iconShape: 'star',
        products: [
            'privateContent',
            'youthContent',
            'travel',
            'car',
            'accident',
            'youngAccident',
            'childAccident',
            'dog'
        ]
    },
    {
        label: 'Hus & hjem',
        iconShape: 'house-sun',
        products: ['house', 'holidayHome', 'privateContent', 'youthContent', 'changeOfOwnership']
    },
    {
        label: 'Transport',
        iconShape: 'car-van-side',
        products: ['car', 'motorcycle', 'boat', 'moped', 'caravan']
    },
    {
        label: 'Rejse & fritid',
        iconShape: 'plane',
        products: [
            'holidayHome',
            'travel',
            'singleTripTravel',
            'singleTripTravelCancellation',
            'boat',
            'caravan'
        ]
    },
    {
        label: 'Helbred & Job',
        iconShape: 'health-cross',
        products: ['accident', 'youngAccident', 'childAccident', 'salaryProtection']
    },
    {
        label: 'Dyr',
        iconShape: 'dog',
        products: ['dog', 'cat', 'horse']
    },
    {
        label: 'Børn & unge',
        iconShape: 'person-boy',
        products: ['youthContent', 'youngAccident', 'childAccident']
    },
    {
        label: 'Alle',
        iconShape: 'circle-plus',
        products: [
            'house',
            'holidayHome',
            'privateContent',
            'youthContent',
            'travel',
            'car',
            'accident',
            'youngAccident',
            'childAccident',
            'salaryProtection',
            'dog',
            'cat',
            'horse',
            'singleTripTravel',
            'singleTripTravelCancellation',
            'motorcycle',
            'boat',
            'moped',
            'caravan',
            'changeOfOwnership'
        ]
    }
];

const products: ProductCollection = {
    house: {
        title: 'Husforsikring',
        iconShape: 'house-sun',
        supported: false
    },
    holidayHome: {
        title: 'Fritidshusforsikring',
        iconShape: 'house-vacation',
        supported: false
    },
    privateContent: {
        title: 'Indboforsikring',
        iconShape: 'furniture',
        supported: true
    },
    youthContent: {
        title: 'Indboforsikring til unge',
        iconShape: 'furniture',
        supported: true
    },
    travel: {
        title: 'Rejseforsikring',
        iconShape: 'plane',
        supported: true
    },
    car: {
        title: 'Bilforsikring',
        iconShape: 'car-front',
        supported: true,
        quantitySelector: true
    },
    accident: {
        title: 'Ulykkeforsikring',
        iconShape: 'broken-leg',
        quantitySelector: true,
        supported: true
    },
    youngAccident: {
        title: 'Ulykkesforsikring til unge',
        iconShape: 'person-girl',
        quantitySelector: true,
        supported: true
    },
    childAccident: {
        title: 'Børneforsikring',
        iconShape: 'boy-girl',
        quantitySelector: true,
        supported: true
    },
    dog: {
        title: 'Hundeforsikring',
        iconShape: 'dog',
        quantitySelector: true,
        supported: true
    },
    cat: {
        title: 'Katteforsikring',
        iconShape: 'cat',
        quantitySelector: true,
        supported: true
    },
    horse: {
        title: 'Hesteforsikring',
        iconShape: 'horse-02',
        quantitySelector: true,
        supported: false
    },
    salaryProtection: {
        title: 'Lønsikring',
        iconShape: 'money-stack',
        supported: false
    },
    singleTripTravel: {
        title: 'Enkeltrejseforsikring',
        iconShape: 'plane',
        supported: false
    },
    singleTripTravelCancellation: {
        title: 'Afbestilling af enkeltrejse',
        iconShape: 'ticket',
        supported: false
    },
    motorcycle: {
        title: 'Motorcykelforsikring',
        iconShape: 'motorbike',
        supported: false
    },
    boat: {
        title: 'Bådforsikring',
        iconShape: 'boat',
        supported: false
    },
    moped: {
        title: 'Knallertforsikring',
        iconShape: 'scooter',
        supported: false
    },
    caravan: {
        title: 'Campingvognsforsikring',
        iconShape: 'caravan',
        supported: false
    },
    changeOfOwnership: {
        title: 'Ejerskifteforsikring',
        iconShape: 'house-sun',
        supported: false
    }
};

export { categories, products, type Category, type ProductKey };
